import skeleton from '../../../components/skeleton';
import vueSeamlessScroll from "vue-seamless-scroll";
import banner from "../../../components/banner";
import news from "../../../components/news";
import pay from "../../../components/pay";
import QRCode from "../../../components/QRCode";
import maskPDF from "../../../components/maskPDF";
import customerTalk from "../../../components/customerTalk";
import './caseGas.less'
export default {
    name: "caseGas",
    data() {
        return {
            black:{
                info: '',
                title: '收款小精灵通过连接移动支付和会员营销，让加油站及其便利店更好地为顾客提供便捷的支付和高效通知，增强加油站用户的粘性。店主还可以通过线上引导提升非油业务收入，通过对会员和数据的高效运营，构建可自我成长的“人·车·生活”的生态圈'
            },
            info: [
                {
                    title: '顾客自助付款，便捷安全',
                    pic: 'img/caseGas/info1.png',
                    info: [
                        '车主进站无需下车，扫员工码付款',
                        '自助选择油枪油号，输入金额',
                        '收银台语音播报，油站不漏单',
                        '支付即会员'
                    ],
                    block: ''
                },
                {
                    title: '油品调价，免费通知车主',
                    pic: 'img/caseGas/info2.png',
                    info: [
                        '油价的实时变动可以通过微信服务通知和模版消息，一键发送',
                        '自助选择油枪油号，输入金额',
                        '收银台语音播报，油站不漏单'
                    ],
                    block: 'swap'
                },
                {
                    title: '积分换券，拉动商品销售',
                    pic: 'img/caseGas/info3.png',
                    info: [
                        '设置会员消费或储值送积分',
                        '设置积分商城和兑换规则',
                        '会员可用积分兑换礼品券，线上化能力让他／她的积分变动实时可查'
                    ],
                    block: ''
                },
                {
                    title: '多门店会员管理，数据可视',
                    pic: 'img/caseGas/info4.png',
                    info: [
                        '会员不论在哪个门店发展，都可以被总部统一管理',
                        '支持根据RFM模型自动会员分层',
                        '支持按男女/按门店/按储值消费行为自定义筛选会员人群，极大提升运营效率'
                    ],
                    block: 'swap'
                }
            ],
            rollList: [
                {
                    src: "/img/caseGas/lun1.png",
                    size: 4,
                },
                {
                    src: "/img/caseGas/lun2.png",
                    size: 2,
                },
                {
                    src: "/img/caseGas/lun3.png",
                    size: 3,
                },
                {
                    src: "/img/caseGas/lun4.png",
                    size: 4,
                }
            ],
            gas: {
                title: '加油站',
                more: '更多加油站案例',
                num: 3,
                info: [
                    {
                        pic: "/img/caseGas/gas1.png",
                        title: "【中国油联文登宏利站】通过服务通知，把发券核销率做到24.5%",
                        txt: "会员每周一次服务通知发券触达，一次免费触达3万+会员，通过洗车券、商超券、玻璃水兑换券等，发券核券率达24.5%",
                        pdf: ""
                    },
                    {
                        pic: "/img/caseGas/gas2.png",
                        title: "加油站还可以这样玩把付费礼包，【君达石化】一个国庆售卖出9万张券",
                        txt: "会员付费39.9元即可购买价值100元的加油代金券（含5张20元券）每次可以消费1张，仅2020年国庆7天，售卖礼包18000个+，卖券9万张！",
                        pdf: "",
                    },

                    {
                        pic: "/img/caseGas/gas3.png",
                        title: "【开封中油】电子会员开卡免费领洗车券，上线第二天业绩翻倍",
                        txt: "强制废除实体会员卡，电子会员开卡即送免费洗车券，上线当天增长了1500会员，第二天销售业绩直接翻倍！",
                        pdf: "",
                    },

                    {
                        pic: "/img/caseGas/gas4.png",
                        title: "咸宁【中润石化】，开启超级消费返现模式秒杀周围几十个竞争对手",
                        txt: "会员消费笔笔返现！按照消费金额返现5%直接到会员余额（不可提现，仅品牌门店可使用），持续性锁定消费者！",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseGas/gas5.png",
                        title: "卧龙【龙联加油站】仅用一个员工二维码，双11开卡4000张",
                        txt: "绑定6个员工，员工推荐客人开卡，一毛钱一张开卡，仅仅一个双十一前后有3天时间，门店开卡量突破4000张",
                        pdf: "",
                    },
                    {
                        pic: "/img/caseGas/gas6.png",
                        title: "临沂市【双龙加油站】储值升级关联会员优惠权益，一招拉动千万储值",
                        txt: "储值500元，享受金卡会员98折；储值1000元，享受钻石会员95折；储值2000元，享受vip会员9折；30个店一年储值破千万",
                        pdf: "",
                    },
                ]
            },
            customerTalk1: {
                bg: '#e1e5f5',
                pic: 'img/caseGas/person1.png',
                info: '“收款小精灵的数字化系统让我们把油品和非油品的销售连成一体，非常顺畅地提升销售额，车主的体验也很好。”',
                person: ' — 陆先生，中国油联文登宏利站， 站长'
            }
        }
    },
    components: {
        skeleton,
        banner,
        news,
        customerTalk,
        pay,
        QRCode,
        maskPDF,
        vueSeamlessScroll
    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        },
    }
}
